module.exports = __webpack_public_path__ + "static/telecommute-card-9711a0d30dfae42a6c57503306dcfc8d.png";